(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .controller('oddCampaignInviteDetailsFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'govNotificationDelay', 'notificationService', 'oddCampaignService'];

    function Controller($scope, $timeout, $state, govNotificationDelay, notificationService, oddCampaignService) {

        $scope.ctrlCtxt = {};

        // Create Or Update
        $scope.createOrUpdateCampaignInviteDetails = function () {
            
            if ($scope.form.$invalid) {
                $scope.ctrlCtxt.showSubmitError = true;

                $scope.ctrlCtxt.isFormInvalidMsgShow = true;
                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isLoading = true;
            // Create Campaign Invite Details
            if (_.isUndefined($scope.boxModel.ODDInviteDetailsID)) {
                
                return oddCampaignService
                        .createODDCampaignInviteDetails($scope.boxContext.Campaign.ODDBusinessUnitID,
                                                        $scope.boxContext.Campaign.ODDExternalPartyID,
                                                        $scope.boxContext.Campaign.ODDCampaignID,
                                                        $scope.boxModel)
                        .then(function (createdInviteDetails) {

                            notificationService.notify('Your changes have been saved');

                            $scope.boxContext.Campaign.ODDInviteDetails = $scope.boxContext.Campaign.ODDInviteDetails || [];
                            $scope.boxContext.Campaign.ODDInviteDetails.push(createdInviteDetails);

                            $scope.form.$setPristine();
                        })
                        .finally(function () {
                            $scope.ctrlCtxt.isLoading = false;
                        });
            }
            else {
                return oddCampaignService
                         .updateODDCampaignInviteDetails($scope.boxContext.Campaign.ODDBusinessUnitID,
                                                         $scope.boxContext.Campaign.ODDExternalPartyID,
                                                         $scope.boxContext.Campaign.ODDCampaignID,
                                                         $scope.boxModel)
                         .then(function (updateInvideDetails) {

                             notificationService.notify('Your changes have been saved');

                             var indexOfInviteDetails = _.findIndex($scope.boxContext.Campaign.ODDInviteDetails, {
                                 ODDInviteDetailsID: updateInvideDetails.ODDInviteDetailsID
                             });
                             if (indexOfInviteDetails >= 0){
                                 $scope.boxContext.Campaign.ODDInviteDetails[indexOfInviteDetails] = updateInvideDetails;
                             }
                             
                             $scope.form.$setPristine();
                         })
                         .finally(function () {
                             $scope.ctrlCtxt.isLoading = false;
                         });
            }
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go($state.$current.parent.name, { reload: true });
        };
    }

})();